<template>
  <text-component :label="label"
                  class="date"
                  :value="getValue"
  />
</template>

<script>
import textComponent from '@/components/backoffice/type/text'
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  components: {
    textComponent
  },
  mixins: [formatter],
  props: {
    value: {
      type: String
    },
    label: String,
    width: String
  },
  computed: {
    valueClass () {
      if (this.label) {
        if (this.width === 'large') {
          return 'col-10'
        } else {
          return 'col-8'
        }
      }
    },
    labelClass () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    },
    getValue () {
      return this.formatDateWithDay(this.value)
    }
  }
}
</script>
